export default __webpack_public_path__ + "static/media/goal5.af0f272d.webp";